import axios from 'axios';
import { BrandId } from '@/shared/models/Brand';
import User, { UserId } from '@/shared/models/User';
import { Lookup, present } from '@/shared/utils/typescript';
import { formatTestDrive, formatTestDriveUpdate, parseReasons, parseTestDrive, parseTestDrives } from '../converters/testDriveConverters';
import { DossierId } from '../models/AbstractDossier';
import TestDrive, { TestDriveId } from '../models/TestDrive';
import TestDriveData from '../models/TestDriveData';
import TestDriveReason from '../models/TestDriveReason';

export default class TestDriveClient {
  static async loadAll(dossierId: DossierId, lookupUser: Lookup<UserId, User>): Promise<Array<TestDrive>> {
    const response = await axios.get(`/api/mobopro/v1/dossiertestdrives?dossierid=${dossierId}`);
    return parseTestDrives(response.data).map(td => this.linkUsers(td, lookupUser));
  }

  static async loadReasons(brandId: BrandId): Promise<Array<TestDriveReason>> {
    const response = await axios.get(`/api/mobopro/v1/dossiertestdrivereasons?brandid=${brandId}`);
    return parseReasons(response.data);
  }

  static async create(data: TestDriveData, dossierId: DossierId, lookupUser: Lookup<UserId, User>): Promise<TestDrive> {
    const response = await axios.post('/api/mobopro/v2/dossiertestdrives', formatTestDrive(data, dossierId));
    return this.linkUsers(present(parseTestDrive(response.data)), lookupUser);
  }

  static async update(data: TestDriveData, testDrive: TestDrive): Promise<TestDrive> {
    const response = await axios.patch(`/api/mobopro/v2/dossiertestdrives/${testDrive.id}`, formatTestDriveUpdate(data));
    return this.linkUsers(present(parseTestDrive(response.data)), () => testDrive.createdBy);
  }

  static async remove(id: TestDriveId): Promise<void> {
    await axios.delete(`/api/mobopro/v1/dossiertestdrives/${id}`);
  }

  private static linkUsers(testDrive: TestDrive, lookupUser: Lookup<UserId, User>): TestDrive {
    testDrive.createdBy = lookupUser(testDrive.createdBy?.id);
    return testDrive;
  }
}